export default __webpack_public_path__ + "static/media/icons-trip-48-px.e2a2f114.svg";